import { type DrawingStatusCode, type NormalizedDrawing } from "@repo/api";
import { Badge, type BadgeProps } from "@repo/skapa";
import { translateDrawingStatusCode } from "@repo/ui";

function getColor(status: DrawingStatusCode): BadgeProps["colour"] {
  if (status === "LOCKED") {
    return "grey";
  }

  if (status === "APPROVED") {
    return "green";
  }

  if (status === "IN_REVIEW") {
    return "orange";
  }
  if (status === "CO_CREATED") {
    return "yellow";
  }

  return "grey";
}

export const PlannerDrawingLabel = ({
  drawingInfo,
}: {
  drawingInfo: NormalizedDrawing;
}) => {
  if (!drawingInfo?.statusCodeTranslated) {
    return null;
  }

  const status = drawingInfo?.statusCodeNotTranslated ?? "DEFAULT";

  const text = drawingInfo.statusCodeTranslated.includes(".")
    ? translateDrawingStatusCode(status)
    : drawingInfo.statusCodeTranslated;

  if (status === "DEFAULT") {
    return null;
  }

  const color = getColor(status);

  return (
    // The div here makes the Pill not take 100% width
    <Badge colour={color} label={text} size="small" />
  );
};
